export default class Text {
  constructor(idioma) {
    this.idioma = idioma || "br";
  }

  getTextoHeader() {
    switch (this.idioma) {
      case "br":
        return `Entre em contato conosco!`;
      case "us":
        return `Talk with us!`;
      default:
        return `Undefined Language`;
    }
  }

  getTextoInput() {
    switch (this.idioma) {
      case "br":
        return [`Nome`, `E-mail`, `Telefone`, `Mensagem`];
      case "us":
        return [`Name`, `E-mail`, `Phone Number`, `Message`];
      default:
        return [
          `Undefined Language`,
          `Undefined Language`,
          `Undefined Language`,
          `Undefined Language`,
        ];
    }
  }

  getTextoSelect() {
    switch (this.idioma) {
      case "br":
        return [
          `Administrativo`,
          `Comercial`,
          `Desenvolvimento`,
          `Financeiro`,
          `Infraestrutura`,
          `Jurídico`,
          `Licitações`,
        ];
      case "us":
        return [
          `Administrative`,
          `Commercial`,
          `Development`,
          `Financial`,
          `Infrastructure`,
          `Legal`,
          `Biddings`,
        ];
      default:
        return [`Undefined Language`, `Undefined Language`];
    }
  }

  getEmailSelect() {
    const host = `@cityconnect.com.br`;
    return [
      `administrativo${host}`,
      `comercial${host}`,
      `dev5${host}`,
      `financeiro${host}`,
      `ti${host}`,
      `juridico${host}`,
      `licitacoes${host}`,
    ];
  }

  getTextoFill() {
    switch (this.idioma) {
      case "br":
        return `Por favor, preencha as informações para contato abaixo`;
      case "us":
        return `Please fill the information needed for contact bellow`;
      default:
        return `Undefined Language`;
    }
  }

  getTituloResumo1() {
    switch (this.idioma) {
      case "br":
        return `Confiam em nosso serviço.`;
      case "us":
        return `Trust our service.`;
      default:
        console.log("Idioma não referenciado");
    }
  }

  getTituloResumo2() {
    switch (this.idioma) {
      case "br":
        return `Fique tranquilo com os dados pessoais e \n informações importantes de sua empresa.`;
      case "us":
        return `Rest assured about your personal information and important information from your business.`;
      default:
        console.log("Idioma não referenciado");
    }
  }

  getTopico1() {
    switch (this.idioma) {
      case "br":
        return `Larga experiência no fornecimento de serviços para redes sem fio, fornecendo consultoria, venda e Mão de obra e wireless.`;
      case "us":
        return `Large experience in providing services for wireless networks, providing consulting, sales and labor and wireless.`;
      default:
        console.log("Idioma não referenciado");
    }
  }

  getTopico2() {
    switch (this.idioma) {
      case "br":
        return `Soluções em telecomunicações, telefonia e interfonia para empresas, consomínios e até mesmo residências.`;
      case "us":
        return `Solutions in telecommunications, telephony and intercom for companies, consom-even residences.`;
      default:
        console.log("Idioma não referenciado");
    }
  }

  getTopico3() {
    switch (this.idioma) {
      case "br":
        return `Montagem de servidores web, arquivos, firewall, dedicados, domínio, redundância e backup.`;
      case "us":
        return `Assembly of web servers, files, firewall, dedicated, domain, redundancy and backup.`;
      default:
        console.log("Idioma não referenciado");
    }
  }

  getBotão2() {
    switch (this.idioma) {
      case "br":
        return `Saiba mais`;
      case "us":
        return `Learn more`;
      default:
        console.log("Idioma não referenciado");
    }
  }

  getTextoRodape() {
    switch (this.idioma) {
      case "br":
        return `As diretrizes e politicas de privacidade de informações de nossos clientes são entendidas como prioridade por toda equipe da City Connect. Desta forma não cedemos informações referentes a nossos clientes a terceiros.`;
      case "us":
        return `
                Our customers' information privacy policies and guidelines are understood as a priority by the entire City Connect team. In this way we do not give information about our customers to third parties.`;
      default:
        return `Undefined Language`;
    }
  }

  getDireitosReservados() {
    switch (this.idioma) {
      case "br":
        return `Todos os direitos reservados - @ City Connect`;
      case "us":
        return `All rights reserved - @ City Connect`;
      default:
        console.log("Idioma não referenciado");
    }
  }

  getTextSetor() {
    switch (this.idioma) {
      case "br":
        return `Setor para contatar`;
      case "us":
        return `Department to message`;
      default:
        return `Undefined Language`;
    }
  }

  getTextoMatriz() {
    switch (this.idioma) {
      case "br":
        return {
          br: [
            `Sede: Volta Redonda`,
            `Rua 41C, Nº 409 - Vila Santa Cecílica`,
            `CEP: 27255-430`,
            `24 3337-7525 / 24 98128-3076`,
            `HORÁRIO DE FUNCIONAMENTO`,
            `Segunda à Sexta - 08:30 às 17:30`,
          ],
          us: [
            `Filial: EUA - Orlando - Flórida`,
            `845 N Garland Ave, ste 100`,
            `Zip Code: 32801`,
            `+1 (321) 295-7474`,
            `HORÁRIO DE FUNCIONAMENTO`,
            `Segunda à Sexta - 09h às 17h`,
          ],
        };
      case "us":
        return {
          br: [
            `Corporate: Brazil - Volta Redonda - RJ`,
            `Street 41C, N° 409 - Vila Santa Cecílica`,
            `CEP: 27255-430`,
            `24 3337-7525 / 24 98128-3076`,
            `BUSINESS HOURS`,
            `Monday to Friday - 08:30 am to 5:30 pm`,
          ],
          us: [
            `Branch: USA - Orlando - FL`,
            `845 N Garland Ave, ste 100`,
            `Zip Code: 32801`,
            `+1 (321) 295-7474`,
            `BUSINESS HOURS`,
            `Monday to Friday - 9am to 5pm`,
          ],
        };
      default:
        return {
          br: [
            `Undefined Language`,
            `Undefined Language`,
            `Undefined Language`,
            `Undefined Language`,
            `Undefined Language`,
            `Undefined Language`,
          ],
          us: [
            `Undefined Language`,
            `Undefined Language`,
            `Undefined Language`,
            `Undefined Language`,
            `Undefined Language`,
            `Undefined Language`,
          ],
        };
    }
  }

  getTextNewContato() {
    switch (this.idioma) {
      case "br":
        return `Enviar nova mensagem`;
      case "us":
        return `Send a new message`;

      default:
        return `Undefined Language`;
    }
  }

  getTextSuccess() {
    switch (this.idioma) {
      case "br":
        return `Sua mensagem foi enviada com sucesso!`;
      case "us":
        return `Your message was successfully sent!`;

      default:
        return `Undefined Language`;
    }
  }

  getOsSystem() {
    switch (this.idioma) {
      case "br":
        return `Sistema de OS`;
      case "us":
        return `OS System`;
      default:
        return `Undefined Language`;
    }
  }

  getPassword() {
    switch (this.idioma) {
      case "br":
        return `senha`;
      case "us":
        return `password`;
      default:
        return `Undefined Language`;
    }
  }

  getUsername() {
    switch (this.idioma) {
      case "br":
        return `nome de usuário`;
      case "us":
        return `username`;
      default:
        return `Undefined Language`;
    }
  }

  getLogin() {
    switch (this.idioma) {
      case "br":
        return `Entrar`;
      case "us":
        return `Sign in`;
      default:
        return `Undefined Language`;
    }
  }

  getError() {
    switch (this.idioma) {
      case "br":
        return `O seguinte erro ocorreu: `;
      case "us":
        return `The following error has ocurred: `;
      default:
        return `Undefined Language`;
    }
  }

  getTryAgain() {
    switch (this.idioma) {
      case "br":
        return `Tente novamente`;
      case "us":
        return `Try again`;
      default:
        return `Undefined Language`;
    }
  }
}
